const query = {
    caseDetail: 'case-detail',
    caseFile: 'case-file',
    caseFileList: 'case-file-list',
    userStatuses: 'user-statuses',
    caseDuplicates: 'case-duplicates',
    callLogs: 'call-logs',
    lawFirmsList: 'law-firms',
    referredLawFirms: 'referred-law-firms',
    rejectionReasons: 'rejection-reasons',
    assignedCases: 'assigned-cases',
    assignedCasesCount: 'assigned-cases-count',
    followUpCases: 'follow-up-cases',
    followUpCasesCount: 'follow-up-cases-count',
    comments: 'comments',
    addComment: 'add-comment',
    sharedCases: 'shared-cases',
    sharedCasesCount: 'shared-cases-count',
    caseStatuses: 'case-statuses',
    referralStatuses: 'referral-statuses',
    allCases: 'all-cases',
    allCasesCount: 'all-cases-count',
    referredCases: 'referred-cases',
    referredCasesCount: 'referred-cases-count',
    lawFirmFollowUp: 'law-firm-follow-ups',
    addCampaign: 'add-campaign',
    getCampaignQuestions: 'get-campaign-questions',
    getDocusignStatus: 'get-docusign-status',
    getDocusignLink: 'get-docusign-link',
    getDocusignEnvelope: 'get-docusign-envelope',
    putDocusignEnvelope: 'put-docusign-envelope',
    sendDocusignEnvelope: 'send-docusign-envelope',
    userProfile: 'user-profile',
    tokenTwilio: 'token-twilio',
    answeringCall: 'answering-calls',
    communication: 'communication',
    campaignNames: 'campaign-names'
};

export default query;
